import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSLTConfig } from '../../slt/config/SLTConfigProvider';
import { ScarcityLabel } from './ScarcityLabel';

export const LimitedQuantityLabel: FC = () => {
    const { customPreferences } = useSLTConfig();
    return (
        <ScarcityLabel id="scarcity-label-limited-quantity-label">
            {customPreferences.limitedQuantityBadgeLabel ? (
                customPreferences.limitedQuantityBadgeLabel
            ) : (
                <FormattedMessage
                    id="scarcity.label.limited.quantity"
                    defaultMessage="Limited Availability"
                />
            )}
        </ScarcityLabel>
    );
};
